import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

// GET_FOLDER_LIST
export const getFolderList = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.MATERIAL.GET_FOLDER_LIST,
    { params: params }
  );

  console.log("🚀 ~ MaterialRepo.ts:11 ~ getFolderList ~ response:", response);

  return response?.data;
};

export const getFolderParentList = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.MATERIAL.GET_FOLDER_PARENT,
    { params: params }
  );

  console.log(
    "🚀 ~ MaterialRepo.ts:21 ~ getFolderParentList ~ response:",
    response
  );

  return response?.data;
};

export const addFolder = async (body?: any) => {
  const response = await axiosInstance.post(
    API_ENDPOINTS.MATERIAL.ADD_FOLDER,
    body
  );

  console.log("🚀 ~ MaterialRepo.ts:36 ~ addFolder ~ response:", response);

  return response?.data;
};

export const getSingleFolderListData = async (id?: string | number) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.MATERIAL.GET_FOLDER_SINGLE_LIST}/${id}`
  );

  console.log(
    "🚀 ~ MaterialRepo.ts:46 ~ getSingleFolderListData ~ response:",
    response
  );

  return response?.data;
};

// UPDATE_FOLDER
export const updateFolder = async (id: string | number, body?: any) => {
  const response = await axiosInstance.put(
    `${API_ENDPOINTS.MATERIAL.UPDATE_FOLDER}/${id}`,
    body
  );

  return response?.data;
};

// GET_FILES_LISTS
export const getFilesList = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.MATERIAL.GET_FILES_LISTS,
    { params: params }
  );

  return response?.data;
};

// GET_SINGLE_FILE
// export const getSingleFilesData = async (
//   params?: Record<string, any>,
//   id?: string | number
// ) => {
//   const response = await axiosInstance.get(
//     `${API_ENDPOINTS.MATERIAL.GET_SINGLE_FILE}/${id}`,
//     { params: params }
//   );

//   return response?.data;
// };

// ADD_FILE
export const addFile = async (body?: any) => {
  const response = await axiosInstance.post(
    API_ENDPOINTS.MATERIAL.ADD_FILE,
    body
  );

  console.log("🚀 ~ MaterialRepo.ts:94 ~ addFile ~ response:", response);

  return response?.data;
};

export const updateFile = async (id?: string | number, body?: any) => {
  const response = await axiosInstance.put(
    `${API_ENDPOINTS.MATERIAL.UPDATE_FILE}/${id}`,
    body
  );

  console.log("🚀 ~ MaterialRepo.ts:105 ~ updateFile ~ response:", response);

  return response?.data;
};

export const getMediaConfig = async (params?: any) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.MATERIAL.GET_MEDIA_CONFIG,
    { params: params }
  );

  console.log(
    "🚀 ~ MaterialRepo.ts:116 ~ getMediaConfig ~ response:",
    response
  );

  return response?.data;
};

export const addMediaConfig = async (body?: any) => {
  const response = await axiosInstance.post(
    `${API_ENDPOINTS.MATERIAL.ADD_MEDIA_CONFIG}`,
    body
  );

  console.log(
    "🚀 ~ MaterialRepo.ts:130 ~ addMediaConfig ~ response:",
    response
  );

  return response?.data;
};

export const updateMediaConfig = async (body?: any) => {
  const response = await axiosInstance.put(
    `${API_ENDPOINTS.MATERIAL.UPDATE_MEDIA_CONFIG}`,
    body
  );

  console.log(
    "🚀 ~ MaterialRepo.ts:143 ~ updateMediaConfig ~ response:",
    response
  );

  return response?.data;
};
